import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { surveyGroupIdAtom } from '../../atoms'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query SurveyGroupFilterInformation_Main($surveyGroupId: ID!) {
    surveyGroup(surveyGroupId: $surveyGroupId) {
      id
      surveys {
        id
        customerAttributeGroups {
          id
          customerAttributes {
            name
          }
        }
      }
      questions {
        id
        name
        answerOptions {
          option
          text
        }
      }
      customerAttributeGroups {
        id
        name
        attachedCustomerAttributeGroups {
          surveyId
          customerAttributeGroupId
        }
        customerAttributes {
          id
          name
        }
      }
      brands {
        id
        name
      }
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useMainQueryKey()
  const surveyGroupId = useAtomValue(surveyGroupIdAtom)

  return useQuery({
    enabled: exists(surveyGroupId),
    queryFn: () => graphQLRequest({ document, variables: { surveyGroupId } }),
    queryKey,
  })
}
